import styled from 'styled-components';
import ArrowDownIcon from '../../../../../../../../public/images/icons/arrow_down.svg';

export const SectionHeaderContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  padding: '8px 0px',
});

const ToggleArrow = styled(ArrowDownIcon)<{ $isExpanded: boolean }>(({ theme, $isExpanded }) => ({
  fill: theme.colors.inactiveBlack,
  cursor: 'pointer',
  transform: $isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.3s ease',
}));

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isExpanded: boolean;
};

const TransparentButton = styled.button({
  background: 'transparent',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  width: 20,
  height: 20,
});

export const SectionToggle = (props: ButtonProps) => {
  const { isExpanded, ...rest } = props;

  return (
    <TransparentButton {...rest}>
      <ToggleArrow $isExpanded={isExpanded} />
    </TransparentButton>
  );
};

export const ShipmentsContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
}));
